import React from 'react'
import styled from 'styled-components'
import ScrollContainer from 'react-indiana-drag-scroll'
import PropTypes from 'prop-types'

import { TopColorBar } from '../SelectSubscriptionPlanScreen/SelectSubscriptionPlanScreen'
import NavigationBar from '../MainScreen/subComponents/NavigationBar'
import DropdownMenu from '../MainScreen/subComponents/DropdownMenu'
import { WelcomeHeader, WelcomeSubHeader } from '../MainScreen/MainScreen'
import EndtryHeader from '../shared/EntryHeader'
import { fontSizeResponsive, mediaQ } from '../theme/mixins'
import BackButton from '../shared/BackButton'

const CompareScreenContainer = styled.div``

const CompareScreenMainContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const ScrollableImageComparisionContainer = styled(ScrollContainer)`
  width: 45%;
  align-self: center;
  display: -webkit-inline-box;
  -webkit-mask-image: linear-gradient(
    90deg,
    rgba(239, 239, 239, 0) -5%,
    rgba(255, 255, 255, 1) 10%,
    rgba(255, 255, 255, 1) 95%,
    rgba(239, 239, 239, 0) 105%
  );
  mask-image: linear-gradient(
    90deg,
    rgba(239, 239, 239, 0) -5%,
    rgba(255, 255, 255, 1) 10%,
    rgba(255, 255, 255, 1) 95%,
    rgba(239, 239, 239, 0) 105%
  );

  cursor: grab;
  padding: 20px 0;
  ${mediaQ('mobileAll', 'width: 95vw;')}
`

const Image = styled.div`
  width: 20vw;
  height: 50vh;
  margin: 0 5px;
  background: ${(props) =>
    props.backgroundSrc ? `url(${props.backgroundSrc})` : '#efefef'};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  box-shadow: 15px 15px 15px -14px rgba(0, 0, 0, 0.3);

  ${mediaQ('mobileAll', 'width: 40vw;')}
`

const CompareScreenInformationsContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`

const CompareScreenInformations = styled.div`
  width: 45%;
  border-top: rgba(254, 13, 159, 0.1) 2px solid;
  margin-top: 20px;
  display: flex;

  ${mediaQ('mobileAll', 'width: 100%;')}
`

const CompareScreenOldInformation = styled.div`
  width: 50%;
  padding-left: 7%;

  span {
    font-family: 'Asap Condensed';
    ${fontSizeResponsive(21)};
    font-weight: normal;
    font-stretch: condensed;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: normal;
    text-align: left;
    color: #fe0d9f;
  }
`

const CompareScreenEntryInformation = styled.div`
  width: 50%;
`

const CompareInformationRow = styled.div`
  width: 100%;
  margin: 20px 0;

  font-family: 'Asap Condensed';
  font-size: ${(props) =>
    props.first ? fontSizeResponsive(27) : fontSizeResponsive(21)};
  font-weight: normal;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  letter-spacing: normal;
  text-align: left;
  color: ${(props) => (props.first ? '#212121' : '#fe0d9f')};

  b {
    font-weight: bold;
  }

  span {
    font-family: 'Asap Condensed';
    ${fontSizeResponsive(21)};
    font-weight: bold;
    font-stretch: condensed;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: normal;
    text-align: left;
    color: #fe0d9f;
    padding-right: 20px;
    display: inline-block;
  }
`
const CompareHeader = styled.h2`
  font-family: 'Asap Condensed';
  ${fontSizeResponsive(45)};
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  letter-spacing: normal;
  text-align: left;
  color: #fe0d9f;
  display: inline-block;
  width: 100%;
  text-align: center;
  margin-top: 20px;
`
const CompareSubHeader = styled.h3`
  width: 100%;
  font-family: 'Asap Condensed';
  font-weight: normal;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  -webkit-letter-spacing: normal;
  -moz-letter-spacing: normal;
  -ms-letter-spacing: normal;
  letter-spacing: normal;
  width: 100%;
  text-align: center;
  ${fontSizeResponsive(24)};

  color: #212121;
`
const ImageContainer = styled.div`
  display: flex;
  padding: 5px;
  border: 2px solid rgba(158, 13, 254, 0.1);
  border-radius: 3px;
  margin: 0 5px;
  position: relative;
`

const ImageLabel = styled.div`
  font-family: 'Asap Condensed';
  font-weight: normal;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  -webkit-letter-spacing: normal;
  -moz-letter-spacing: normal;
  -ms-letter-spacing: normal;
  letter-spacing: normal;
  text-align: center;
  ${fontSizeResponsive(24)};
  color: #fe0d9f;
  font-weight: bold;
  /* border-right: 2px solid rgba(158, 13, 254, 0.1);
  border-left: 2px solid rgba(158, 13, 254, 0.1);
  border-top: 2px solid rgba(158, 13, 254, 0.1); */
  position: absolute;
  top: -12px;
  background: white;
  width: 50px;
  left: calc(50% - 25px);
`

const CompareScreen = ({
  openMenu,
  onOpenMenuClick,
  onSubpageChange,
  isPlayerActive,
  changeLocation,
  closeMenu,
  entry,
  goBack,
  currentEntrySideImage,
  currentEntryFrontImage,
  currentEntryBackImage,
  oldEntryFrontImage,
  oldEntryBackImage,
  oldEntrySideImage,
  user,
  currentFeed,
  earliestFeed,
}) => {
  return (
    <CompareScreenContainer>
      <TopColorBar relative>
        <BackButton
          place={'Porównanie wpisów'}
          specialLocation={'/trening'}
          isActive={true}
        />
      </TopColorBar>
      <NavigationBar

        isNavDropdownVisible={openMenu}
        onOpenMenuClick={onOpenMenuClick}
        onSubpageChange={onSubpageChange}
        isPlayerActive={isPlayerActive}
        changeLocation={changeLocation}
      />
      {openMenu && (
        <DropdownMenu
          closeMenu={closeMenu}
          isVisible={openMenu}
          changeLocation={changeLocation}
        />
      )}

      <CompareHeader>Porównanie wpisów</CompareHeader>

      <CompareSubHeader>
        {earliestFeed.creation_datetime} - {currentFeed.creation_datetime}
      </CompareSubHeader>

      <CompareScreenMainContent>
        <ScrollableImageComparisionContainer
          className="scroll-container"
          id="scrollContainer"
        >
          <ImageContainer side="side">
            <Image mode="sideStart" backgroundSrc={oldEntrySideImage} />
            <Image mode="sideCurrent" backgroundSrc={currentEntrySideImage} />
            <ImageLabel>BOK</ImageLabel>
          </ImageContainer>
          <ImageContainer side="front">
            <Image mode="frontStart" backgroundSrc={oldEntryFrontImage} />
            <Image mode="frontCurrent" backgroundSrc={currentEntryFrontImage} />
            <ImageLabel>PRZÓD</ImageLabel>
          </ImageContainer>
          <ImageContainer side="back">
            <Image mode="backStart" backgroundSrc={oldEntryBackImage} />
            <Image mode="backCurrent" backgroundSrc={currentEntryBackImage} />
            <ImageLabel>TYŁ</ImageLabel>
          </ImageContainer>
        </ScrollableImageComparisionContainer>

        <CompareScreenInformationsContainer>
          <CompareScreenInformations>
            <CompareScreenOldInformation>
              <CompareInformationRow first>
                <b>{earliestFeed.creation_datetime}</b>
              </CompareInformationRow>
              <CompareInformationRow second>
                <span>{earliestFeed.belly_circumference}</span>
                <span divider>/</span>
                <span>{earliestFeed.hip_circumference}</span>
                <span divider>/</span>
                <span>{earliestFeed.thigh_circumference}</span>
              </CompareInformationRow>
            </CompareScreenOldInformation>
            <CompareScreenEntryInformation>
              <CompareInformationRow first>
                <b>{currentFeed.creation_datetime}</b>
              </CompareInformationRow>
              <CompareInformationRow second>
                <span>{currentFeed.belly_circumference}</span>
                <span divider>/</span>
                <span>{currentFeed.hip_circumference}</span>
                <span divider>/</span>
                <span>{currentFeed.thigh_circumference}</span>
              </CompareInformationRow>
            </CompareScreenEntryInformation>
          </CompareScreenInformations>
        </CompareScreenInformationsContainer>
      </CompareScreenMainContent>
    </CompareScreenContainer>
  )
}

CompareScreen.propTypes = {
  openMenu: PropTypes.bool.isRequired,
  onSubpageChange: PropTypes.func.isRequired,
  onOpenMenuClick: PropTypes.func.isRequired,
  isPlayerActive: PropTypes.bool,
  changeLocation: PropTypes.func.isRequired,
  closeMenu: PropTypes.func.isRequired,
  entry: PropTypes.objectOf(PropTypes.any).isRequired,
  goBack: PropTypes.func.isRequired,
  currentEntrySideImage: PropTypes.objectOf(PropTypes.any).isRequired,
  currentEntryFrontImage: PropTypes.objectOf(PropTypes.any).isRequired,
  currentEntryBackImage: PropTypes.objectOf(PropTypes.any).isRequired,
  oldEntryFrontImage: PropTypes.objectOf(PropTypes.any).isRequired,
  oldEntryBackImage: PropTypes.objectOf(PropTypes.any).isRequired,
  oldEntrySideImage: PropTypes.objectOf(PropTypes.any).isRequired,
  user: PropTypes.objectOf(PropTypes.any).isRequired,
}

CompareScreen.defaultProps = { isPlayerActive: false }

export default CompareScreen
